import { Link } from "react-router-dom";
import { useState } from "react";
import PopupIcons from "../components/PopupIcons";
import PopupLightbox from "../components/PopupLightbox";
import MiddleY from "../components/MiddleY";

import soaboa from "../images/soa-boa.jpg";
import imgBrianV from "../images/bio/brian-v.jpg";
import kevinS from "../images/bio/kevin-s.jpg";
import shelbiC from "../images/bio/alumni/shelbiC.jpg";
import imgConference from "../images/thumbs/conference.jpg";
import imgMoney from "../images/thumbs/money.jpg";
import imgReport from "../images/thumbs/magnify-report.jpg";
import graphFundraise from "../images/25/fundraising-report-cashflow.png";
import graphMapAlumni from "../images/25/graph-states-alumni.png";
import listAlumniInternational from "../images/25/list-alumni-international.png";
import graphAlumni from "../images/25/alumni-numbers.png";

const HomePage = () => {
  const [buttonPopupA, setButtonPopupA] = useState(false);
  const [buttonPopupB, setButtonPopupB] = useState(false);
  const [buttonPopupC, setButtonPopupC] = useState(false);
  const updateButtonPopupB = (newValue) => {
    setButtonPopupB(newValue);
  };

  const [buttonPopupC1, setButtonPopupC1] = useState(false);
  const [buttonPopupC2, setButtonPopupC2] = useState(false);
  const [buttonPopupC4, setButtonPopupC4] = useState(false);

  return (
    <>
      <div className="grid-container">
        <div className="grid-item grid-a">
          <button className="primary-buttons button-a" onClick={() => setButtonPopupA(true)}>
            <svg width="100%" height="100%" viewBox="0 0 300 300" className="circle-title">
              <path id="bottom-path" d="M50,150 a100,100 0 0,1 200,0" fill="none" stroke="none" />

              <text fontSize="34" fill="white">
                <textPath href="#bottom-path" startOffset="50%" textAnchor="middle">
                  Emeriti & Retirements
                </textPath>
              </text>
            </svg>
          </button>
        </div>
        <div className="grid-item grid-b">
          <button className="primary-buttons button-b" onClick={() => setButtonPopupB(true)}>
            <svg width="100%" height="100%" viewBox="0 0 300 300" className="circle-title">
              <path id="bottom-path" d="M50,150 a100,100 0 0,1 200,0" fill="none" stroke="none" />

              <text fontSize="34" fill="white">
                <textPath href="#bottom-path" startOffset="50%" textAnchor="middle">
                  Faculty & Students
                </textPath>
              </text>
            </svg>
          </button>
        </div>
        <div className="grid-item grid-c">
          <button className="primary-buttons button-c" onClick={() => setButtonPopupC(true)}>
            <svg width="100%" height="100%" viewBox="0 0 300 300" className="circle-title">
              <path id="bottom-path" d="M50,150 a100,100 0 0,1 200,0" fill="none" stroke="none" />

              <text fontSize="34" fill="white">
                <textPath href="#bottom-path" startOffset="50%" textAnchor="middle">
                  Alumni
                </textPath>
              </text>
            </svg>
          </button>
        </div>
        <PopupIcons trigger={buttonPopupA} setTrigger={setButtonPopupA} columnPosition="colA">
          <ul className="circle-container">
            <li>
              <Link
                to="/retirements/"
                className="image-btn image-link"
                style={{ backgroundImage: `url(${imgBrianV})` }}
              >
                <span>Retirement</span>
              </Link>
            </li>
            <li>
              <Link to="/emeriti/" className="image-btn image-link" style={{ backgroundImage: `url(${kevinS})` }}>
                <span>Emeriti</span>
              </Link>
            </li>
          </ul>
        </PopupIcons>

        {/* MIDDLE Y */}
        <MiddleY buttonPopupB={buttonPopupB} onUpdatePopupB={updateButtonPopupB} />

        <PopupIcons trigger={buttonPopupC} setTrigger={setButtonPopupC} columnPosition="colC">
          <ul className="circle-container">
            <li>
              <Link
                className="image-btn image-link"
                style={{ backgroundImage: `url(${imgConference})` }}
                onClick={() => setButtonPopupC1(true)}
              >
                <span>Board of Advisors</span>
              </Link>
            </li>
            <li>
              <Link
                className="image-btn image-link"
                style={{ backgroundImage: `url(${imgMoney})` }}
                onClick={() => setButtonPopupC2(true)}
              >
                <span>Annual Donations</span>
              </Link>
            </li>
            <li>
              <Link
                to="/alumni-highlights/"
                className="image-btn image-link"
                style={{ backgroundImage: `url(${shelbiC})` }}
              >
                <span>Alumni Highlights</span>
              </Link>
            </li>
            <li>
              <Link
                className="image-btn image-link"
                style={{ backgroundImage: `url(${imgReport})` }}
                onClick={() => setButtonPopupC4(true)}
              >
                <span>Alumni Report #'s</span>
              </Link>
            </li>
          </ul>
        </PopupIcons>

        <PopupLightbox
          trigger={buttonPopupC1}
          setTrigger={setButtonPopupC1}
          columnPosition="lightbox"
          slugCategory={""}
        >
          <img src={soaboa} alt="SOA Board of Advisors" />
        </PopupLightbox>

        <PopupLightbox trigger={buttonPopupC2} setTrigger={setButtonPopupC2} columnPosition="colB" slugCategory={""}>
          <h3>Annual Donations </h3>
          <img src={graphFundraise} alt="graph report" />
        </PopupLightbox>

        <PopupLightbox
          trigger={buttonPopupC4}
          setTrigger={setButtonPopupC4}
          columnPosition="lightbox"
          slugCategory={""}
        >
          <h3>Alumni Report #'s</h3>
          <img src={graphMapAlumni} alt="graph report" />
          <img src={listAlumniInternational} alt="graph report" />
          <img src={graphAlumni} alt="graph report" />
        </PopupLightbox>
      </div>
    </>
  );
};

export default HomePage;
